import { Search } from "lucide-react";
import { RANK_FILTERS } from "../../data/goetia";
import { useLang } from "../../config/i18n";

export const FilterBar = ({ filter, setFilter, query, setQuery }) => {
  const { t } = useLang();
  const g = t.goetia;

  return (
  <div data-testid="goetia-filter-bar" className="sticky top-[72px] z-40 -mx-6 px-6 py-4 bg-[#0A0A0C]/92 backdrop-blur-xl border-b border-[#22222B]">
    <div className="max-w-6xl mx-auto flex flex-col gap-4">
      <div className="relative">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6E6E7D]" />
        <input
          data-testid="goetia-search-input"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={g.searchPlaceholder}
          className="w-full min-h-[48px] pl-11 pr-4 rounded-sm bg-[#121216] border border-[#22222B] text-sm text-[#F7F7F8] placeholder-[#6E6E7D] font-light focus:outline-none focus:border-[#C5A059]/60 transition-colors"
        />
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-none -mx-6 px-6 sm:mx-0 sm:px-0 sm:flex-wrap">
        {RANK_FILTERS.map(({ id }) => (
          <button
            key={id}
            data-testid={`goetia-filter-${id}`}
            onClick={() => setFilter(id)}
            className={`shrink-0 min-h-[40px] px-4 rounded-sm text-[10px] font-semibold tracking-[0.14em] uppercase border transition-colors duration-300 ${
              filter === id
                ? "bg-[#D9A94A] text-[#0A0A0C] border-[#D9A94A]"
                : "text-[#A3A3AF] border-[#22222B] hover:border-[#C5A059]/50 hover:text-[#C5A059]"
            }`}
          >
            {g.filterLabels[id]}
          </button>
        ))}
      </div>
    </div>
  </div>
  );
};
